import request from '@/utils/request'
import { 
  getTrialOrders, 
  getTrialOrderDetail,  // 使用原始导入名称
  updateTrialOrder,     // 使用原始导入名称
  deleteTrialOrder,     // 使用原始导入名称
  completeTrialOrder,
  cancelTrialOrder 
} from '@/services/trialOrderApi'
export default {
  namespaced: true,
  state: {
    orders: [],
    total: 0,
    trialOrders: [],
    trialTotal: 0
  },
  mutations: {
    SET_TRIAL_ORDERS(state, orders) {
      state.trialOrders = orders
    },
    SET_TRIAL_ORDERS_TOTAL(state, total) {
      state.trialOrdersTotal = total
    },
    SET_CURRENT_TRIAL_ORDER(state, order) {
      state.currentTrialOrder = order
    },
    SET_ORDERS(state, orders) {
      console.log('原始订单数据:', orders)
      
      // 处理可能的嵌套数据结构
      const processedOrders = Array.isArray(orders) 
        ? orders 
        : (orders.data || orders.list || [])

      console.log('处理后的订单数据:', processedOrders)

      // 确保 processedOrders 是数组，并为每个订单添加默认值
      state.orders = (processedOrders || []).map(order => ({
        orderNo: '',
        customerName: '',
        vin: '',
        amount: 0,
        status: '',
        createTime: '',
        items: [],
        ...order
      }))

      console.log('最终存储的订单数据:', state.orders)
    },
    SET_TOTAL(state, total) {
      console.log('设置总记录数:', total)
      state.total = total || 0
    }
  },
  actions: {
// 获取试配订单详情
async getTrialOrderDetail({ commit }, orderId) {
  try {
    const response = await getTrialOrderDetail(orderId)
    if (response && response.code === 200) {
      commit('SET_CURRENT_TRIAL_ORDER', response.data)
    }
    return {
      code: response?.code || 500,
      data: response?.data || null,
      message: response?.message || '获取订单详情失败'
    }
  } catch (error) {
    console.error('获取试配订单详情失败:', error)
    return {
      code: 500,
      data: null,
      message: error.message || '获取订单详情失败'
    }
  }
},
  // 删除试配订单
async deleteTrialOrder({ dispatch }, payload) {
  try {
    console.log('删除试配订单, 参数:', typeof payload === 'object' ? payload : { id: payload });
    // 处理两种不同的参数格式
    const orderId = typeof payload === 'object' ? payload.id : payload;
    
    // 调用API删除订单
    const response = await deleteTrialOrder(orderId);
    console.log('删除试配订单响应:', response);
    
    if (response && response.code === 200) {
      // 删除成功后刷新列表
      await dispatch('fetchTrialOrders', {
        page: 0,
        size: 10
      });
      return {
        code: 200,
        message: '删除成功'
      }
    }
    return {
      code: response?.code || 500,
      message: response?.message || '删除失败'
    }
  } catch (error) {
    console.error('删除试配订单失败:', error);
    return {
      code: 500,
      message: error.message || '删除失败'
    }
  }
},
    // 更新试配订单
    async updateTrialOrder({ dispatch }, orderData) {
      try {
        const response = await updateTrialOrder(orderData)
        if (response && response.code === 200) {
          await dispatch('fetchTrialOrders')
        }
        return {
          code: response?.code || 500,
          data: response?.data || null,
          message: response?.message || '更新订单失败'
        }
      } catch (error) {
        console.error('更新试配订单失败:', error)
        return {
          code: 500,
          data: null,
          message: error.message || '更新订单失败'
        }
      }
    },
    async fetchTrialOrders({ commit }, params) {
      try {
        const response = await getTrialOrders(params)
        console.log('API response:', response)
        if (response.code === 200) {
          commit('SET_TRIAL_ORDERS', response.data)
          commit('SET_TRIAL_ORDERS_TOTAL', response.data.length)
        }
        return response
      } catch (error) {
        console.error('获取试配订单列表失败:', error)
        throw error
      }
    },
    
    async completeTrialOrder({ dispatch }, { orderId, data }) {
      try {
        const response = await completeTrialOrder(orderId, data)
        if (response.code === 200) {
          await dispatch('fetchTrialOrders')
        }
        return response
      } catch (error) {
        console.error('完成试配订单失败:', error)
        throw error
      }
    },
    
    async cancelTrialOrder({ dispatch }, { orderId, reason }) {
      try {
        const response = await cancelTrialOrder(orderId, reason)
        if (response.code === 200) {
          await dispatch('fetchTrialOrders')
        }
        return response
      } catch (error) {
        console.error('取消试配订单失败:', error)
        throw error
      }
    },
    async fetchOrders({ commit }, params = {}) {
      try {
        const { 
          page = 0,
          size = 10,
          customerName = '',
          status = '',
          startDate = '',
          endDate = ''
        } = params

        const response = await request({
          url: '/api/orders',
          method: 'get',
          params: {
            page,
            size,
            customerName,
            status,
            startDate,
            endDate
          }
        })
        
        console.log('订单列表完整响应:', response)

        if (response.code === 200) {
          // 处理不同的响应数据结构
          let ordersData = [];
          let totalElements = 0;

          if (response.data?.content) {
            // Spring Data JPA 分页格式
            ordersData = response.data.content;
            totalElements = response.data.totalElements;
          } else if (Array.isArray(response.data)) {
            // 数组格式
            ordersData = response.data;
            // 如果是第一页且数据量等于页大小，说明可能还有更多数据
            if (page === 0 && ordersData.length === size) {
              totalElements = size * 2; // 至少还有一页
            } else {
              totalElements = page * size + ordersData.length;
            }
          } else if (response.data?.list) {
            // 带有list的格式
            ordersData = response.data.list;
            totalElements = response.data.total || response.data.list.length;
          }

          console.log('解析后的订单数据:', ordersData);
          console.log('当前页码:', page);
          console.log('页大小:', size);
          console.log('数据条数:', ordersData.length);
          console.log('计算的总数量:', totalElements);
          
          // 确保每个订单都有正确的类型和状态
          const processedOrders = ordersData.map(order => {
            // 检查订单项是否包含负数金额，用于判断是否为退货单
            const hasNegativeAmount = order.orderItems?.some(item => 
              (item.amount && item.amount < 0) || 
              (item.quantity && item.price && (item.quantity * item.price < 0))
            );

            // 计算订单总金额
            let totalAmount = 0;
            if (order.orderItems && order.orderItems.length > 0) {
              totalAmount = order.orderItems.reduce((total, item) => {
                const itemAmount = item.amount || (item.quantity * item.price) || 0;
                return total + itemAmount;
              }, 0);
            } else {
              totalAmount = order.amount || 0;
            }

            return {
              ...order,
              orderType: order.orderType || (hasNegativeAmount ? 'return' : 'normal'),
              status: order.status || 'pending',
              amount: hasNegativeAmount ? -Math.abs(totalAmount) : totalAmount
            };
          });
          
          commit('SET_ORDERS', processedOrders)
          // 确保总数量至少等于当前页的数据量加上之前页的数据量
          const minimumTotal = (page + 1) * size;
          commit('SET_TOTAL', Math.max(totalElements, minimumTotal))
        } else {
          console.error('获取订单列表失败:', response)
          commit('SET_ORDERS', [])
          commit('SET_TOTAL', 0)
        }
      } catch (error) {
        console.error('获取订单列表失败:', error)
        commit('SET_ORDERS', [])
        commit('SET_TOTAL', 0)
        throw error
      }
    }
  }
} 